export var mixin = {
  methods: {
    checkPassword(password) {
      let dator = new this.$Dator.Dator();
      let paterns = [{ 
        strategy: "isEmpty",
        //  errMsg: "請輸入密碼" 
        errMsg:this.language('ui.placeholderPassword')
        }];
      paterns.push({
        strategy: "checkPassworld",
        // errMsg: "密碼必須同時包括字母及數字",
        errMsg:this.language('ui.placeholderPassword4')

      });
      dator.add(password, paterns);
      if (dator.getErrmsg()) {
        return dator.getErrmsg();
      } else {
        return "";
      }
    },
    checkPasswordSame(password, password2,oldPassword) {
      let dator = new this.$Dator.Dator();
      let paterns = [{ strategy: "isEmpty", 
      // errMsg: "請輸入密碼" 
      errMsg:this.language('ui.placeholderPassword')

    }];
      paterns.push({
        strategy: "checkPassworld",
        // errMsg: "密碼必須同時包括字母及數字",
        errMsg:this.language('register.placeholder4')

      });
      dator.add(password2, paterns);
      if (dator.getErrmsg()) {
        return dator.getErrmsg();
      } else {
        if (password2 != password) {
          return this.language('ui.placeholderPassword3')
          // return "兩次輸入密碼不一致";
        }else if(oldPassword && password2 == password && password2 == oldPassword){
          return this.language('userData.tipsText54')

          // return "新舊密碼不可一致";
        } else {
          return "";
        }
      }
    },
  },
};
